import { Injectable } from '@angular/core';
import { map, catchError } from 'rxjs/operators';
import { Subject, Observable } from 'rxjs';
import { MobilePivotModel } from 'lib/ng2-sapmp/src/ui-components/mobile-pivot';

@Injectable()
export class UserWizardService {
    private sessionStorageName = 'assign-wizard';
    private subject = new Subject<string>();
    private pivotSubject = new Subject<Array<MobilePivotModel>>();

    // Method to add Source
    public addAssignOrUnassignWizard(userWizard) {
        sessionStorage.setItem(this.sessionStorageName, JSON.stringify(userWizard));
    }

    public fetchSessionData() {
        return JSON.parse(sessionStorage.getItem(this.sessionStorageName));
    }

    // Add ProductList
    public addProductList(userWizard) {
        this.addAssignOrUnassignWizard(userWizard);
    }

    public setMessage(message: string) {
        this.subject.next(message);
    }

    public getMessage() {
        return this.subject.asObservable();
    }

    public setPivot(pivot: Array<MobilePivotModel>) {
        this.pivotSubject.next(pivot);
    }

    public getPivot() {
        return this.pivotSubject.asObservable();
    }

    public removeAssignOrUnassignWizard() {
        sessionStorage.removeItem(this.sessionStorageName);
        sessionStorage.removeItem('steps-manageUsers');
    }
}